import MiniLazyload from "./src/minilazyload";
export default MiniLazyload;